import { render, staticRenderFns } from "./BudgetVariantAndStaffTabVersionTemplate.vue?vue&type=template&id=85c6d1d8&"
import script from "./BudgetVariantAndStaffTabVersionTemplate.vue?vue&type=script&lang=ts&"
export * from "./BudgetVariantAndStaffTabVersionTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports